import {MODEL_LOAD, MODEL_START,MODEL_ERROR, ENABLE_TITLE_CHANGE} from '../actions/model.action.js';
import {default_state} from './index.js';

export function model(state=default_state.model, action={}){
    switch (action.type){
        case MODEL_START:
            return {
                ...state,
                isbn13 : action.isbn13
            };

        case MODEL_LOAD:
            return {
                ...state,
                review_data: action.review_data,
                has_sub : action.is_subscriber,
                chapters : action.chapters,
                model_loaded : true,
                error : false
            };

        case MODEL_ERROR:
            return {
                ...state,
                error : action.error
            };
        case ENABLE_TITLE_CHANGE:
            return{
                ...state,
                enableTitleChange: true
            }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/model.reducer.js